import {gql} from '@apollo/client'

export const GET_IMOVEL_CORRETORES = gql`
  query GetImovelCorretor($idTerreno: Float!, $showInativos: Float) {
    GetImovelCorretor(id_terreno: $idTerreno, show_inativos: $showInativos) {
      id
      situacao
      corretor {
        id
        nome
        telefone
        email
        situacao
        empresa
      }
    }
  }
`
